import { render, staticRenderFns } from "./ComponentFrame.vue?vue&type=template&id=fd90ebc4&scoped=true"
import script from "./ComponentFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentFrame.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd90ebc4",
  null
  
)

export default component.exports